<template>
  <div class="video-container video-con-l big">
    <div v-if="isLogin && isclickedPlay" id="video1" style="width:687px; height: 400px"></div>
    <div
      v-else
      :class="{
        'video-con-l': true,
        por: true,
        small: isHome,
        big: isSYKT,
      }"
    >
      <img :src="item.bigimagehttpurl" alt="" class="pic" />
      <div class="video-con-l-con poa txt-overflow">
        <img
          src="../assets/images/player.png"
          alt=""
          class="player"
          @click="play()"
        />
        <span>{{ item.videoTitle }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["downloadUrl", "isHome", "isSYKT"],
  data() {
    return {
			myPlayer1: null,
			time:"",//视频当前播放的时间
			item:{},
      isclickedPlay: false,
    };
  },
	created(){
		// this.setCookie('admin')
		let user_name = this.getCookie('user_name')
		this.isLogin = !!user_name
	},
  methods: {
    play() {
      this.isclickedPlay = true;
      if (!this.isLogin) return this.$message.warning("请登录后观看！");
      else {
				if(this.myPlayer1) {
					this.myPlayer1.changeMediaId(this.item.videoMediaID)
					// this.myPlayer1.changeControlBarShow(true)	
				}
				else this.loadCKplayer(this.item)
			}
    },
    // uggBJ9nqOmVQCBUp5Wt5U
    		//视频播放插件
		loadCKplayer(item){
			this.item = item
			if(!this.isLogin) return
			let videoObject={
				platformId: 'uggBJ9nqOmVQCBUp5Wt5U', //平台注册码 (分测试、正式)
				container: '#video1', //容器的ID或className
				loop: false, //播放结束是否循环播放
				autoplay: false, //是否自动播放(由于个别浏览器问题，设置自动播放时，需手动开启音量)
				// seek: 3, //默认跳转的时间
				mediaId: item.videoMediaID,
				debug: false, //是否开启调试模式
				env: 'pro',
				mobileCkControls: true,//是否在移动端（包括ios）环境中显示控制栏
				config:{
					playbackRate:true,
					definition:true
				},
				style:{
					logo:{
						file:''
					}
				}
			}
      
			this.myPlayer1 = new ckplayer(videoObject);
			
		},
		changeMedia(item) {
      this.item = item;
      this.isclickedPlay = false;
			if(this.myPlayer1) {
				this.myPlayer1.dispose()
				this.myPlayer1 = null
			}
    },
		//获取cookie值
		getCookie(cname) {
			var name = cname + "=";
			var ca = document.cookie.split(";");
			// console.log(document.cookie);
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i].trim();
				if (c.indexOf(name) == 0)
					return c.substring(name.length, c.length);
			}
			return "";
		},
		//存储cookie值
		setCookie(name, exdate) {
			// 设置cookie
			var exDate = new Date();
			exDate.setTime = exDate.getTime() + 24 * 60 * 60 * 1000 * exdate; // cookie 保存十天
			// 字符串拼接cookie
			window.document.cookie = "user_name=" + name;
		},
		loadHandler() {
			this.myPlayer1.addListener('error', errorHandler); //监听视频加载出错
			this.myPlayer1.addListener('loadedmetadata', loadedMetaDataHandler); //监听元数据
			this.myPlayer1.addListener('duration', durationHandler); //监听播放时间
			this.myPlayer1.addListener('time', timeHandler); //监听播放时间
			this.myPlayer1.addListener('play', playHandler); //监听播放
			this.myPlayer1.addListener('pause', pauseHandler); //监听暂停播放
			this.myPlayer1.addListener('buffer', bufferHandler); //监听缓冲状态
			this.myPlayer1.addListener('seek', seekHandler); //监听跳转播放完成
			this.myPlayer1.addListener('seekTime', seekTimeHandler); //监听跳转播放完成
			this.myPlayer1.addListener('volume', volumeChangeHandler); //监听音量改变
			this.myPlayer1.addListener('full', fullHandler); //监听全屏/非全屏切换
			this.myPlayer1.addListener('ended', endedHandler); //监听播放结束
			this.myPlayer1.addListener('screenshot', screenshotHandler); //监听截图功能
			this.myPlayer1.addListener('mouse', mouseHandler); //监听鼠标坐标
			this.myPlayer1.addListener('controlBar', controlBarHandler); //监听控制栏显示隐藏事件
			this.myPlayer1.addListener('clickEvent', clickEventHandler); //监听点击事件
			this.myPlayer1.addListener('videoClick', videoClickHandler); //监听播放器单击事件
			this.myPlayer1.addListener('definitionChange', definitionChangeHandler); //监听清晰度切换事件
			this.myPlayer1.addListener('loadTime', loadTimeHandler); //监听加载速度
		},
		videoClickHandler(obj){
				// console.log(obj);
			},
			errorHandler() {
				changeText('playerstate', '状态：视频加载错误，停止执行其它动作，等待其它操作');
			},

			loadedMetaDataHandler() {
				var metaData = this.myPlayer1.getMetaDate();
				var html = ''
				if(parseInt(metaData['videoWidth']) > 0) {
					changeText('playerstate', '状态：获取到元数据信息，如果数据错误，可以使用延迟获取');
					html += '总时间：' + metaData['duration'] + '秒，';
					html += '音量：' + metaData['volume'] + '（范围0-1），';
					html += '播放器的宽度：' + metaData['width'] + 'px，';
					html += '播放器的高度：' + metaData['height'] + 'px，';
					html += '视频宽度：' + metaData['videoWidth'] + 'px，';
					html += '视频高度：' + metaData['videoHeight'] + 'px，';
					html += '视频原始宽度：' + metaData['streamWidth'] + 'px，';
					html += '视频原始高度：' + metaData['streamHeight'] + 'px，';
					html += '是否暂停状态：' + metaData['paused']+ '，';
					html += '已加载时间：' + metaData['loadTime']+'秒，';
					html += '版本号：' + metaData['version'];
				} else {
					changeText('playerstate', '状态：未正确获取到元数据信息');
					html = '没有获取到元数据';
				}
				changeText('metadata', html);
			},
			playHandler() {
				changeText('playstate', + '播放状态： 播放');
				window.setTimeout(function() {
					loadedMetaDataHandler();
				}, 1000);
				loadedMetaDataHandler();
			},

			pauseHandler() {
				//this.myPlayer1.animatePause();//暂停所有弹幕
				changeText('playstate','播放状态： 暂停');
				loadedMetaDataHandler();
			},

			timeHandler(time) {
				changeText('currenttimestate', '当前播放时间（秒）：' + time);
			},

			durationHandler(duration) {
				changeText('duration', '总时间（秒）：' + duration);
			},
			seekHandler(state) {
				changeText('seekstate',  "跳转状态:"+state);
			},

			seekTimeHandler(time) {
				changeText('seekstate',' seekTime:' + time);
			},

			bufferHandler(buffer) {
				changeText('bufferstate', '缓冲：' + buffer);
			},

			volumeChangeHandler(vol) {
				changeText('volumechangestate', '当前音量：' + vol);
			},
			loadTimeHandler(t) {
				changeText('loadtime', '当前加载的时间：' + t);
			},
			screenshotHandler(obj) {

				changeText('screenshot', '图片名称：' + obj['name'] + ',截图对象：' + obj['object'] + ',是否用户保存：' + obj['save'] + ',图片：<img src="' + obj['base64'] + '">');
			},

			fullHandler(b) {
				if(b) {
					html = ' 全屏';
				} else {
					html = ' 否';
				}
				changeText('fullstate',html);

			},

			endedHandler() {
				changeText('endedstate', '播放结束');
			},

			mouseHandler(obj) {
				changeText('mouse', '鼠标位置，x：' + obj['x'] + '，y：' + obj['y']);
			},

			controlBarHandler(show){
				if(show) {
					html = ' 显示';
				} else {
					html = ' 隐藏';
				}
				changeText('controlBar',  html);
			},
			clickEventHandler(eve){
				changeText('clickEvent', eve);
			},
			definitionChangeHandler(num){
				changeText('definitionChange',  '切换清晰度编号'+num);
			},



			deletePlayer(){
				if(this.myPlayer1){
					this.myPlayer1.dispose();
					this.myPlayer1=null
				}

			},

			changeText(div, text) {
				document.getElementsByClassName(div)[0].innerHTML=text
			},



		newVideo() {
			var mediaId = this.myPlayer1.getByElement('.mediaId').value;
			if(this.myPlayer1 == null) {
				return;
			}
			this.myPlayer1.changeMediaId(mediaId)
		},
  },
};
</script>
<style lang="scss" scoped>
.video-con-l {
  width: 519px;
  height: 295px;
  display: block;
  cursor: pointer;
  &.small {
    width: 458.54px;
    height: 267px;
  }
  &.big {
    width: 687px;
    height: 400px;
  }
  .pic {
    width: 100%;
    height: 100%;
  }
  .player {
		width: 28px;
		height: 28px;
		margin-right: 15px;
		vertical-align: middle;
		display: inline-block;
  }
  .video-con-l-con {
    color: #fff;
    bottom: 0;
    height: 44px;
    line-height: 40px;
    width: 100%;
    padding: 0 18px;
    // font-weight: bold;
    background: linear-gradient(rgba(0, 0, 0, 0.66),#000);
    .name {
      font-size: 15px;
      width: 80%;
      padding-left: 18px;
    }
    .time {
      font-size: 15px;
      padding-right: 9px;
    }
  }
}
</style>